<template>
  <div class="get_started_list_section achievements_section achievements_main achievements_prof" v-if="userDetails.gamesPlayed >= 0">
    <div class="tab-content active" id="achievements-tab">
      <div class="achievements_box">
        <div class="achievements_books">
          <p class="unlocked_txt">{{ getTranslations.achievements_profile_unlocked_txt }} <span>{{this.userDetails.achievements}}/11</span></p>
          <img :src=getAchievementBookPath(this.userDetails.achievements) class="books_img">
        </div>
      </div>
      <div class="achievement_badges">
<!--        <a-->
<!--          href="#"-->
<!--          class="badge"-->
<!--          v-for="(achievement, index) in achievements[0].achievementDTOs"-->
<!--          :key="index">-->
<!--          <img :src="getAchievementImagePath(achievement)" />-->
<!--          <p>{{ getTranslations[achievement.achievementNameTranslation] }}</p>-->
<!--        </a>-->

        <a
          href="#"
          class="badge"
          v-for="(achievement, index) in formattedAchievements"
          :key="index"
          @click.prevent="showModal(achievement)">
          <base-image :src="getAchievementImagePath(achievement)" type-for-skin="achievement"/>
          <p>{{ getTranslations[`achievement_${achievement.achievementName}`] }}</p>
        </a>
      </div>

    </div>
  </div>
</template>

<script>

import {mapGetters, mapActions, mapState} from 'vuex';
import BaseImage from '../../common/image/BaseImage.vue';


export default {
  name: 'achievements-profile',
  components: { BaseImage },
  emits: ['show:achievement'],
  props: {
    hasFilters: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  created() {
  },
  methods: {
    ...mapActions('profile', [
      'getUserAchievements', // Map Vuex action
    ]),
    getTranslatedValue(index) {
      return this.getTranslations[`home_achievements_category${index}`];
    },

    getAchievementBookPath(book){
      const prefix = book < 10 ? 'A0' : 'A1';
      let adjustedNumber = book < 10 ? book : book - 10;
      adjustedNumber = adjustedNumber === 0 ? 1 : adjustedNumber;
      return `static/images/achievements/${prefix}${adjustedNumber}.png`;
    },

    getAchievementImagePath(achievement) {

      // console.log('Inside AchievementImagePath:::',achievement.achievementLevelDTOs[0])
      const isLocked = achievement.completed ? 'unlocked' : 'locked';
      // Remove only the trailing numbers while keeping the underscore
      let baseName = achievement.achievementLevelName.replace(/_\d+$/, '_');
      // console.log('isLocked::',isLocked)
      // console.log('baseName::',baseName)
      return `static/images/achievements/${baseName}${isLocked}.png`;
    },

    showModal(achievement) {
      this.$emit('show:achievement', achievement);
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'modalForSettings'
    ]),
    ...mapState('profile', [
      'performanceInfo',
      'achievements',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    formattedAchievements() {
      if(!this.achievements[0] || !Array.isArray(this.achievements[0].achievementDTOs)){
        return []
      }

      return this.achievements[0].achievementDTOs.map(achievement => {
        const {achievementLevelName, completed, prizeValue, percentage, threshold} = achievement.achievementLevelDTOs[0] || {}

        return {
          achievementLevelName,
          completed,
          prizeValue,
          percentage,
          threshold,
          achievementName: achievement.achievementName,
          achievementNameTranslation: achievement.achievementNameTranslation
        }
      });
    }
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/profile/AchievementsProfile.vue